import { render, staticRenderFns } from "./FilterChip.vue?vue&type=template&id=6f0c5de2&scoped=true&"
import script from "./FilterChip.vue?vue&type=script&lang=ts&"
export * from "./FilterChip.vue?vue&type=script&lang=ts&"
import style0 from "./FilterChip.vue?vue&type=style&index=0&id=6f0c5de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c5de2",
  null
  
)

export default component.exports